import dayjs, { type Dayjs } from 'dayjs';

export const APPOINTMENT_SCHEDULE_START_HOUR = 10;
export const APPOINTMENT_SCHEDULE_END_HOUR = 19; // 7:00 PM

export const isWithinAppointmentScheduleHours = (time: Dayjs): boolean => {
  const hour = time.hour();
  const minute = time.minute();

  if (hour < APPOINTMENT_SCHEDULE_START_HOUR) return false;
  if (hour > APPOINTMENT_SCHEDULE_END_HOUR) return false;
  if (hour === APPOINTMENT_SCHEDULE_END_HOUR && minute > 0) return false;

  return true;
};

export const clampToAppointmentScheduleHours = (time: Dayjs): Dayjs => {
  let clamped = time.second(0).millisecond(0);

  if (clamped.hour() < APPOINTMENT_SCHEDULE_START_HOUR) {
    clamped = clamped.hour(APPOINTMENT_SCHEDULE_START_HOUR).minute(0);
  } else if (
    clamped.hour() > APPOINTMENT_SCHEDULE_END_HOUR ||
    (clamped.hour() === APPOINTMENT_SCHEDULE_END_HOUR && clamped.minute() > 0)
  ) {
    clamped = clamped.hour(APPOINTMENT_SCHEDULE_END_HOUR).minute(0);
  }

  return clamped;
};

export const getDefaultAppointmentScheduleTime = (): Dayjs => {
  const now = dayjs();
  const minutes = now.minute();
  const roundedMinutes = Math.round(minutes / 15) * 15;
  let defaultTime = now.minute(roundedMinutes).second(0).millisecond(0);

  if (defaultTime.hour() < APPOINTMENT_SCHEDULE_START_HOUR) {
    defaultTime = defaultTime.hour(APPOINTMENT_SCHEDULE_START_HOUR).minute(0);
  } else if (
    defaultTime.hour() > APPOINTMENT_SCHEDULE_END_HOUR ||
    (defaultTime.hour() === APPOINTMENT_SCHEDULE_END_HOUR &&
      defaultTime.minute() > 0)
  ) {
    defaultTime = defaultTime
      .add(1, 'day')
      .hour(APPOINTMENT_SCHEDULE_START_HOUR)
      .minute(0);
  }

  return defaultTime;
};

export const getAppointmentScheduleDisabledTime = () => () => ({
  disabledHours: () => {
    const hours: number[] = [];
    for (let h = 0; h < 24; h++) {
      if (
        h < APPOINTMENT_SCHEDULE_START_HOUR ||
        h > APPOINTMENT_SCHEDULE_END_HOUR
      ) {
        hours.push(h);
      }
    }
    return hours;
  },
  disabledMinutes: (selectedHour: number) => {
    if (selectedHour !== APPOINTMENT_SCHEDULE_END_HOUR) {
      return [];
    }
    const minutes: number[] = [];
    for (let m = 1; m < 60; m++) {
      minutes.push(m);
    }
    return minutes;
  },
});

export const appointmentScheduleTimeProps = {
  disabledTime: getAppointmentScheduleDisabledTime(),
};
